import { render } from "./Register.vue?vue&type=template&id=93f9af46&scoped=true"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=93f9af46&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-93f9af46"

export default script